import React, { useState, useCallback } from 'react';
import { IScimRevokeActionsDialogResult } from 'types/dialogs';
import ScimRevokeActionsDialog, {
	ScimConfirmActionType
} from './ScimRevokeActionsDialog';

const useScimRevokeActionsDialog = () => {
	const [ScimRevokeActionsDialogJsx, setScimRevokeActionsDialogJsx] =
		useState<React.JSX.Element | null>(null);

	const openScimRevokeActionsDialog = useCallback(
		(actionType: ScimConfirmActionType) =>
			new Promise<IScimRevokeActionsDialogResult>((resolve) => {
				setScimRevokeActionsDialogJsx(
					<ScimRevokeActionsDialog
						actionType={actionType}
						onClose={(res: IScimRevokeActionsDialogResult) => {
							setScimRevokeActionsDialogJsx(null);
							resolve(res);
						}}
					/>
				);
			}),
		[]
	);

	return {
		ScimRevokeActionsDialogJsx,
		openScimRevokeActionsDialog
	};
};

export default useScimRevokeActionsDialog;
